import App from '../App'
/**
 * auth true登录才能访问，false不需要登录，默认true
 */

export default [
  {
    path: '/',
    component: App,
    children: [
      {
        path: '/order-evaluate-statics',
        name: 'order-evaluate-statics',
        meta: { auth: true, menu: true, title: '订单评论统计' },
        component: resolve => require(['../pages/query-and-statics/order-evaluate-statics'], resolve)
      },
      {
        path: '/consume-time-statics',
        meta: { auth: true },
        component: resolve => require(['../pages/query-and-statics/consume-time-statics'], resolve)
      },
      {
        path: '/expenditure-quantity-statics',
        name: 'expenditure-quantity-statics',
        meta: { auth: true, menu: true, title: '消费额点菜量统计' },
        component: resolve => require(['../pages/query-and-statics/expenditure-quantity-statics'], resolve)
      },
      {
        path: '/relief-statics',
        meta: { auth: true },
        component: resolve => require(['../pages/query-and-statics/relief-statics'], resolve)
      },
      {
        path: '/withdrawals',
        meta: { auth: true },
        component: resolve => require(['../pages/query-and-statics/withdrawals'], resolve)
      },
      {
        path: '/order-evaluate-search',
        name: 'order-evaluate-search',
        meta: { auth: true, menu: true, title: '订单评论搜索' },
        component: resolve => require(['../pages/query-and-statics/order-evaluate-search'], resolve)
      },
      {
        path: '/patient-beds',
        meta: { auth: true },
        component: resolve => require(['../pages/nutrition/patient-beds'], resolve)
      },
      {
        path: '/calendar-dish-template',
        name: 'calendar-dish-template',
        meta: { auth: true, menu: true, title: '日历排菜' },
        component: resolve => require(['../pages/calendar-dish-template'], resolve)
      },
      {
        path: '/certificate-management',
        name: 'certificate-management',
        meta: { auth: true, menu: true, title: '证书管理' },
        component: resolve => require(['../pages/certificate-management'], resolve)
      },
      {
        path: '/patient-order-stat',
        meta: { auth: true },
        component: resolve => require(['../pages/nutrition/patient-order-stat'], resolve)
      },
      {
        path: '/advice-manage', // 未读医嘱
        meta: { auth: true },
        component: resolve => require(['../pages/advice-manage/advice-manage'], resolve)
      },
      {
        path: '/name-dish-list',
        name: 'name-dish-list',
        meta: { auth: true, menu: true, title: '命名排菜' },
        component: resolve => require(['../pages/daily/arrangement/name/name-dish-list'], resolve)
      },
      {
        path: '/name-template-detail', // 命名排菜模板详情
        meta: { auth: true },
        component: resolve => require(['../pages/daily/arrangement/name/name-template-detail'], resolve)
      },
      {
        path: '/name-dish-list/modify', // 修改命名排菜模板
        meta: { auth: true },
        component: resolve => require(['../pages/daily/arrangement/name/name-template-add-modify'], resolve)
      },
      {
        path: '/name-dish-list/add', // 新增命名排菜模板
        meta: { auth: true },
        component: resolve => require(['../pages/daily/arrangement/name/name-template-add-modify'], resolve)
      },
      {
        path: '/bus-finace-report', // 点餐员设置
        meta: { auth: true },
        component: resolve => require(['../pages/xsbus/bus-finace-report'], resolve)
      },
      {
        path: '/bus-purchasing-list', // 点餐员设置
        meta: { auth: true },
        component: resolve => require(['../pages/xsbus/bus-purchasing-list'], resolve)
      },
      {
        path: '/card-operate',
        name: 'card-operate',
        meta: { auth: true, menu: true, title: '上传员工卡数据' },
        component: resolve => require(['../pages/batch/card-operate'], resolve)
      },
      {
        path: '/home-page',
        name: 'home-page',
        meta: { auth: true, menu: true, title: '首页' },
        component: resolve => require(['../pages/home-page/home-page'], resolve)
      },
      {
        path: '/recharge-monthly-report',
        name: 'recharge-monthly-report',
        meta: { auth: true, menu: true, title: '充值月报表' },
        component: resolve => require(['../pages/recharge/recharge-monthly-report'], resolve)
      },
      {
        path: '/supplement-recharge',
        name: 'supplement-recharge',
        meta: { auth: true, menu: true, title: '餐补充值' },
        component: resolve => require(['../pages/recharge/supplement-recharge'], resolve)
      },
      {
        path: '/supplement-red',
        name: 'supplement-red',
        meta: { auth: true, menu: true, title: '餐补冲红' },
        component: resolve => require(['../pages/recharge/supplement-red'], resolve)
      },
      {
        path: '/cash-red',
        name: 'cash-red',
        meta: { auth: true, menu: true, title: '现金冲红' },
        component: resolve => require(['../pages/recharge/cash-red'], resolve)
      },
      {
        path: '/cash-print',
        name: 'cash-print',
        meta: { auth: true, menu: true, title: '打印收据' },
        component: resolve => require(['../pages/recharge/cash-print'], resolve)
      },
      {
        path: '/cash-recharge',
        name: 'cash-recharge',
        meta: { auth: true, menu: true, title: '现金充值' },
        component: resolve => require(['../pages/recharge/cash-recharge'], resolve)
      },
      {
        path: '/fast-recharge',
        meta: { auth: true },
        component: resolve => require(['../pages/recharge/fast-recharge'], resolve)
      },
      {
        path: '/batch-dish-statics',
        name: 'batch-dish-statics',
        meta: { auth: true, menu: true, title: '分批次菜品统计' },
        component: resolve => require(['../pages/daily-list/batch-dish-statics'], resolve)
      },
      {
        path: '/consume-person-statics',
        name: 'consume-person-statics',
        meta: { auth: true, menu: true, title: '就餐人员统计' },
        component: resolve => require(['../pages/query-and-statics/consume-person-statics'], resolve)
      },
      {
        path: '/consume-dish-statics',
        name: 'consume-dish-statics',
        meta: { auth: true, menu: true, title: '菜品消费统计' },
        component: resolve => require(['../pages/query-and-statics/consume-dish-statics'], resolve)
      },
      {
        path: '/dish-comment-query',
        name: 'dish-comment-query',
        meta: { auth: true, menu: true, title: '菜品评价记录查询' },
        component: resolve => require(['../pages/comments/dish-comment-query'], resolve)
      },
      {
        path: '/dish-comment-statics',
        name: 'dish-comment-statics',
        meta: { auth: true, menu: true, title: '菜品评价统计' },
        component: resolve => require(['../pages/comments/dish-comment-statics'], resolve)
      },
      {
        path: '/comment-score-statics',
        name: 'comment-score-statics',
        meta: { auth: true, menu: true, title: '评价日历' },
        component: resolve => require(['../pages/comments/comment-score-statics'], resolve)
      },
      {
        path: '/register', // 注册
        meta: { auth: false },
        component: resolve => require(['../pages/login/register'], resolve)
      },
      {
        path: '/login', // 登录
        meta: { auth: false },
        component: resolve => require(['../pages/login/login'], resolve)
      },
      {
        path: '/meal-supply-setting',
        name: 'meal-supply-setting',
        meta: { auth: true, menu: true, title: '下月餐补额度设置' },
        component: resolve => require(['../pages/recharge/meal-supply-setting'], resolve)
      },
      {
        path: '/recharge-record-query',
        name: 'recharge-record-query',
        meta: { auth: true, menu: true, title: '充值记录查询' },
        component: resolve => require(['../pages/recharge/recharge-record-query'], resolve)
      },
      {
        path: '/monthly-statistical-statement',
        name: 'monthly-statistical-statement',
        meta: { auth: true, menu: true, title: '月统计报表' },
        component: resolve => require(['../pages/recharge/monthly-statistical-statement'], resolve)
      },
      {
        path: '/department-meal-statics',
        name: 'department-meal-statics',
        meta: { auth: true, menu: true, title: '部门就餐情况统计' },
        component: resolve => require(['../pages/query-and-statics/department-meal-statics'], resolve)
      },
      {
        path: '/hall-revenue-statics',
        name: 'hall-revenue-statics',
        meta: { auth: true, menu: true, title: '食堂营收查询' },
        component: resolve => require(['../pages/query-and-statics/hall-revenue-statics'], resolve)
      },
      {
        path: '/expenses-record-statics',
        name: 'expenses-record-statics',
        meta: { auth: true, menu: true, title: '消费记录查询' },
        component: resolve => require(['../pages/query-and-statics/expenses-record-statics'], resolve)
      },
      {
        path: '/subside-operate',
        name: 'subside-operate',
        meta: { auth: true, menu: true, title: '上传餐补数据' },
        component: resolve => require(['../pages/batch/subside-operate'], resolve)
      },
      {
        path: '/subside-operate2',
        name: 'subside-operate2',
        meta: { auth: true, menu: true, title: '考勤餐补数据' },
        component: resolve => require(['../pages/batch/subside-operate2'], resolve)
      },
      {
        path: '/plan-dish-setting',
        name: 'plan-dish-setting',
        meta: { auth: true, menu: true, title: '手动排菜' },
        component: resolve => require(['../pages/daily/arrangement/plan-dish-setting'], resolve)
      },
      {
        path: '/plan-dish-setting/modify', // 计划菜品修改
        meta: { auth: true },
        component: resolve => require(['../pages/daily/arrangement/plan-dish-modify'], resolve)
      },
      {
        path: '/plan-dish-setting/add', // 计划菜品添加
        meta: { auth: true },
        component: resolve => require(['../pages/daily/arrangement/plan-dish-add'], resolve)
      },
      {
        path: '/dish-setting', // 计划设置
        name: 'dish-setting',
        meta: { auth: true, menu: true, title: '手动排菜' },
        component: resolve => require(['../pages/daily/arrangement/dish-setting'], resolve)
      },
      {
        path: '/dish-setting/add', // 计划添加
        meta: { auth: true },
        component: resolve => require(['../pages/daily/arrangement/dish-setting-add'], resolve)
      },
      {
        path: '/batch-setting',
        name: 'batch-setting',
        meta: { auth: true, menu: true, title: '分批次就餐设置' },
        component: resolve => require(['../pages/setting/batch/batch-setting'], resolve)
      },
      {
        path: '/batch-setting/add', // 新增批次
        meta: { auth: true },
        component: resolve => require(['../pages/setting/batch/batch-add-modify'], resolve)
      },
      {
        path: '/batch-setting/modify', // 修改批次
        meta: { auth: true },
        component: resolve => require(['../pages/setting/batch/batch-add-modify'], resolve)
      },
      {
        path: '/batch-detail', // 批次详情
        meta: { auth: true },
        component: resolve => require(['../pages/setting/batch/batch-detail'], resolve)
      },
      {
        path: '/batch-detail/add', // 批次详情添加
        meta: { auth: true },
        component: resolve => require(['../pages/setting/batch/batch-detail-add'], resolve)
      },
      {
        path: '/hallop-setting',
        name: 'hallop-setting',
        meta: {auth: true, menu: true, title: '食堂操作员设置'},
        component: resolve => require(['../pages/setting/hallop/hallop-setting'], resolve)
      },
      {
        path: '/hallop-setting/add', // 食堂操作员设置
        meta: { auth: true },
        component: resolve => require(['../pages/setting/hallop/hallop-add-modify'], resolve)
      },
      {
        path: '/hallop-setting/modify', // 食堂操作员修改
        meta: { auth: true },
        component: resolve => require(['../pages/setting/hallop/hallop-add-modify'], resolve)
      },
      {
        path: '/waiter-setting',
        name: 'waiter-setting',
        meta: { auth: true, menu: true, title: '点餐员设置' },
        component: resolve => require(['../pages/setting/waiter/waiter-setting'], resolve)
      },
      {
        path: '/waiter-setting/add', // 点餐员设置
        meta: { auth: true },
        component: resolve => require(['../pages/setting/waiter/waiter-add-modify'], resolve)
      },
      {
        path: '/waiter-setting/modify', // 点餐员设置
        meta: { auth: true },
        component: resolve => require(['../pages/setting/waiter/waiter-add-modify'], resolve)
      },
      {
        path: '/manager-setting',
        name: 'manager-setting',
        meta: { auth: true, menu: true, title: '管理员设置' },
        component: resolve => require(['../pages/system/manager/manager-setting'], resolve)
      },
      {
        path: '/manager-setting/add', // 管理员添加
        meta: { auth: true },
        component: resolve => require(['../pages/system/manager/manager-add-modify'], resolve)
      },
      {
        path: '/manager-setting/modify', // 管理员修改
        meta: { auth: true },
        component: resolve => require(['../pages/system/manager/manager-add-modify'], resolve)
      },
      {
        path: '/wehall-setting', // 微信食堂修改
        meta: { auth: true },
        component: resolve => require(['../pages/setting/wechat/wehall-setting'], resolve)
      },
      {
        path: '/wehall-setting/add', // 微信食堂修改
        meta: { auth: true },
        component: resolve => require(['../pages/setting/wechat/wehall-add-modify'], resolve)
      },
      {
        path: '/wehall-setting/modify', // 微信食堂修改
        meta: { auth: true },
        component: resolve => require(['../pages/setting/wechat/wehall-add-modify'], resolve)
      },
      {
        path: '/wehall-detail', // 规则详情
        meta: { auth: true },
        component: resolve => require(['../pages/setting/wechat/wehall-detail'], resolve)
      },
      {
        path: '/wehall-detail/add', // 规则详情新增
        meta: { auth: true },
        component: resolve => require(['../pages/setting/wechat/wehall-detail-add-modify'], resolve)
      },
      {
        path: '/wehall-detail/modify', // 规则详情新增
        meta: { auth: true },
        component: resolve => require(['../pages/setting/wechat/wehall-detail-add-modify'], resolve)
      },
      {
        path: '/random-discount-setting',
        name: 'random-discount-setting',
        meta: { auth: true, menu: true, title: '随机满减活动设置' },
        component: resolve => require(['../pages/setting/hall/random-discount-setting'], resolve)
      },
      {
        path: '/random-discount-setting/add', // 随机满减活添加
        meta: { auth: true },
        component: resolve => require(['../pages/setting/hall/random-discount-add-modify'], resolve)
      },
      {
        path: '/random-discount-setting/modify', // 随机满减活修改
        meta: { auth: true },
        component: resolve => require(['../pages/setting/hall/random-discount-add-modify'], resolve)
      },
      {
        path: '/usergroup-list',
        name: 'usergroup-list',
        meta: { auth: true, menu: true, title: '用户组列表' },
        component: resolve => require(['../pages/setting/usergroups/usergroup-list'], resolve)
      },
      {
        path: '/usergroup-list/add', // 用户组添加
        meta: { auth: true },
        component: resolve => require(['../pages/setting/usergroups/usergroup-add-modify'], resolve)
      },
      {
        path: '/usergroup-list/modify', // 用户组修改
        meta: { auth: true },
        component: resolve => require(['../pages/setting/usergroups/usergroup-add-modify'], resolve)
      },
      {
        path: '/autopay-list',
        name: 'autopay-list',
        meta: { auth: true, menu: true, title: '用户组扣款设置' },
        component: resolve => require(['../pages/setting/usergroups/autopay-list'], resolve)
      },
      {
        path: '/autopay-list/add', // 用户组扣款添加
        meta: { auth: true },
        component: resolve => require(['../pages/setting/usergroups/autopay-add-modify'], resolve)
      },
      {
        path: '/autopay-list/modify', // 用户组扣款修改
        meta: { auth: true },
        component: resolve => require(['../pages/setting/usergroups/autopay-add-modify'], resolve)
      },
      {
        path: '/hall-setting',
        name: 'hall-setting',
        meta: { auth: true, menu: true, title: '食堂设置'},
        component: resolve => require(['../pages/setting/hall/hall-setting'], resolve)
      },
      {
        path: '/stall-setting', // 食堂档口列表
        meta: { auth: true },
        component: resolve => require(['../pages/setting/hall/stall-setting'], resolve)
      },
      {
        path: '/stall-setting/modify', // 食堂档口-修改
        meta: { auth: true },
        component: resolve => require(['../pages/setting/hall/stall-add-modify'], resolve)
      },
      {
        path: '/stall-setting/add', // 食堂档口-添加
        meta: { auth: true },
        component: resolve => require(['../pages/setting/hall/stall-add-modify'], resolve)
      },
      {
        path: '/hall-setting/add', // 食堂设置-新增
        meta: { auth: true },
        component: resolve => require(['../pages/setting/hall/hall-add-modify'], resolve)
      },
      {
        path: '/hall-setting/modify', // 食堂设置-修改
        meta: { auth: true },
        component: resolve => require(['../pages/setting/hall/hall-add-modify'], resolve)
      },
      {
        path: '/department-setting',
        name: 'department-setting',
        meta: { auth: true, menu: true, title: '部门设置' },
        component: resolve => require(['../pages/setting/department/department-setting'], resolve)
      },
      {
        path: '/department-setting/modify', // 食堂设置
        meta: { auth: true },
        component: resolve => require(['../pages/setting/department/department-add-modify'], resolve)
      },
      {
        path: '/department-setting/setting', // 部门充值设置
        meta: { auth: true },
        component: resolve => require(['../pages/setting/department/department-recharge-set'], resolve)
      },
      {
        path: '/position/issueCardSetting', // 职务工本费设置
        meta: { auth: true },
        component: resolve => require(['../pages/setting/position/issueCardSetting'], resolve)
      },
      {
        path: '/department-setting/add', // 食堂设置
        meta: { auth: true },
        component: resolve => require(['../pages/setting/department/department-add-modify'], resolve)
      },
      {
        path: '/position-setting',
        name: 'position-setting',
        meta: { auth: true, menu: true, title: '职务设置' },
        component: resolve => require(['../pages/setting/position/position-setting'], resolve)
      },
      {
        path: '/position-setting/add', // 职务设置-新增
        meta: { auth: true },
        component: resolve => require(['../pages/setting/position/position-add-modify'], resolve)
      },
      {
        path: '/position-setting/modify', // 职务设置-修改
        meta: { auth: true },
        component: resolve => require(['../pages/setting/position/position-add-modify'], resolve)
      },
      {
        path: '/period-name-setting',
        name: 'period-name-setting',
        meta: { auth: true, menu: true, title: '餐段名称设置' },
        component: resolve => require(['../pages/setting/period/period-name-setting'], resolve)
      },
      {
        path: '/period-name-setting/add', // 食堂设置
        meta: { auth: true },
        component: resolve => require(['../pages/setting/period/period-name-add'], resolve)
      },
      {
        path: '/period-name-setting/modify', // 食堂设置
        meta: { auth: true },
        component: resolve => require(['../pages/setting/period/period-name-add'], resolve)
      },
      {
        path: '/period-setting',
        name: 'period-setting',
        meta: { auth: true, menu: true, title: '餐段设置' },
        component: resolve => require(['../pages/setting/period/period-setting'], resolve)
      },
      {
        path: '/period-setting/add', // 食堂设置
        meta: { auth: true },
        component: resolve => require(['../pages/setting/period/period-add'], resolve)
      },
      {
        path: '/period-setting/modify', // 食堂设置
        meta: { auth: true },
        component: resolve => require(['../pages/setting/period/period-add'], resolve)
      },
      {
        path: '/order-delivery',
        name: 'order-delivery',
        meta: { auth: true, menu: true, title: '订单配送' },
        component: resolve => require(['../pages/daily/order-delivery'], resolve)
      },
      {
        path: '/template-dish-arrangement',
        name: 'template-dish-arrangement',
        meta: { auth: true, menu: true, title: '模板排菜' },
        component: resolve => require(['../pages/daily/arrangement/template/template-dish-arrangement'], resolve)
      },
      {
        path: '/template-dish-arrangement/add', //  模板排菜 - 添加菜品
        meta: { auth: true },
        component: resolve => require(['../pages/daily/arrangement/template/template-dish-arrangement-add'], resolve)
      },
      {
        path: '/template-dish-arrangement2', //  模板排菜
        meta: { auth: true },
        component: resolve => require(['../pages/daily/arrangement/template/template-dish-arrangement'], resolve)
      },
      {
        path: '/template-dish-arrangement2/add', //  模板排菜 - 添加菜品
        meta: { auth: true },
        component: resolve => require(['../pages/daily/arrangement/template/template-dish-arrangement-add'], resolve)
      },
      {
        path: '/account-withdraw',
        name: 'account-withdraw',
        meta: { auth: true, menu: true, title: '账号提现' },
        component: resolve => require(['../pages/daily/account/account-withdraw'], resolve)
      },
      {
        path: '/account-withdraw-logs',
        meta: { auth: true },
        component: resolve => require(['../pages/daily/account/account-withdraw-logs'], resolve)
      },
      {
        path: '/base-categories', //  基础菜品库-菜品类目
        name: 'base-categories',
        meta: {auth: true, menu: true, title: '基础菜品库'},
        component: resolve => require(['../pages/operator/dish/base-categories'], resolve)
      },
      {
        path: '/base-categories/add', // 基础菜品库-新增菜品类目
        meta: { auth: true },
        component: resolve => require(['../pages/operator/dish/base-category-add'], resolve)
      },
      {
        path: '/base-categories/modify', // 基础菜品库-修改菜品类目
        meta: { auth: true },
        component: resolve => require(['../pages/operator/dish/base-category-add'], resolve)
      },
      {
        path: '/base-dishes', //  基础菜品库-菜品列表
        meta: { auth: true },
        component: resolve => require(['../pages/operator/dish/base-dishes'], resolve)
      },
      {
        path: '/base-dishes/add', // 基础菜品库-新增菜品
        meta: { auth: true },
        component: resolve => require(['../pages/operator/dish/base-dish-add'], resolve)
      },
      {
        path: '/base-dishes/modify', // 基础菜品库-修改菜品
        meta: { auth: true },
        component: resolve => require(['../pages/operator/dish/base-dish-add'], resolve)
      },
      {
        path: '/dish-materials', // 基础菜品库-选择原材料
        meta: { auth: true },
        component: resolve => require(['../pages/operator/dish/dish-materials'], resolve)
      },
      {
        path: '/op-order-statics',
        name: 'op-order-statics',
        meta: { auth: true, menu: true, title: '操作员订单统计' },
        component: resolve => require(['../pages/operator-statics/op-order-statics'], resolve)
      },
      {
        path: '/ayi-order-statics',
        name: 'ayi-order-statics',
        meta: { auth: true, menu: true, title: '点餐员订单统计' },
        component: resolve => require(['../pages/operator-statics/ayi-order-statics'], resolve)
      },
      {
        path: '/ayi-on-accounts-query',
        name: 'ayi-on-accounts-query',
        meta: { auth: true, menu: true, title: '点餐员挂账对账查询' },
        component: resolve => require(['../pages/operator-statics/ayi-on-accounts-query'], resolve)
      },
      {
        path: '/matirial-purchasing-list',
        name: 'matirial-purchasing-list',
        meta: { auth: true, menu: true, title: '采购清单' },
        component: resolve => require(['../pages/daily-list/matirial-purchasing-list'], resolve)
      },
      {
        path: '/cooking-list',
        name: 'cooking-list',
        meta: { auth: true, menu: true, title: '烧制清单汇总' },
        component: resolve => require(['../pages/daily-list/cooking-list'], resolve)
      },
      {
        path: '/cooking-list-detail',
        name: 'cooking-list-detail',
        meta: { auth: true, menu: true, title: '烧制清单' },
        component: resolve => require(['../pages/daily-list/cooking-list-detail'], resolve)
      },
      {
        path: 'employee-reset-password',
        name: 'employee-reset-password',
        meta: { auth: true, menu: true, title: '重置密码' },
        component: resolve => require(['../pages/setting/employee/employee-reset-password'], resolve)
      },
      {
        path: '/order-query', // 订单查询
        name: 'order-query',
        meta: { auth: true, menu: true, title: '订单查询' },
        component: resolve => require(['../pages/operator/order-query'], resolve)
      },
      {
        path: '/outPayTradeNo-query',
        name: 'outPayTradeNo-query',
        meta: { auth: true, menu: true, title: '充值未到账查询' },
        component: resolve => require(['../pages/operator/outPayTradeNo-query'], resolve)
      },
      {
        path: '/health-query',
        name: 'health-query',
        meta: { auth: true, menu: true, title: '健康打卡查询' },
        component: resolve => require(['../pages/operator/health-query'], resolve)
      },
      {
        path: '/order-detail', // 订单详情
        meta: { auth: true },
        component: resolve => require(['../pages/operator/order-detail'], resolve)
      },
      {
        path: '/staffcar-setting',
        name: 'staffcar-setting',
        meta: { auth: true, menu: true, title: '办卡工本费设置' },
        component: resolve => require(['../pages/setting/staffcar/staffcar-setting'], resolve)
      },
      {
        path: '/makeup-car',
        name: 'makeup-car',
        meta: { auth: true, menu: true, title: '补卡' },
        component: resolve => require(['../pages/setting/staffcar/makeup-car'], resolve)
      },
      {
        path: '/change-car',
        name: 'change-car',
        meta: { auth: true, menu: true, title: '换卡' },
        component: resolve => require(['../pages/setting/staffcar/change-car'], resolve)
      },
      {
        path: '/checkout-car',
        name: 'checkout-car',
        meta: { auth: true, menu: true, title: '退卡' },
        component: resolve => require(['../pages/setting/staffcar/checkout-car'], resolve)
      },
      {
        path: '/face-list',
        name: 'face-list',
        meta: { auth: true, menu: true, title: '人脸数据录入' },
        component: resolve => require(['../pages/setting/face/face-list'], resolve)
      },
      {
        path: '/face-list/add', //  人脸数据录入
        meta: { auth: true },
        component: resolve => require(['../pages/setting/face/face-list-add'], resolve)
      },
      {
        path: '/face-list/modify', //  人脸数据录入
        meta: { auth: true },
        component: resolve => require(['../pages/setting/face/face-list-add'], resolve)
      },
      {
        path: '/label-setting',
        name: 'label-setting',
        meta: { auth: true, menu: true, title: '菜品标签设置' },
        component: resolve => require(['../pages/setting/label/label-setting'], resolve)
      },
      {
        path: '/label-setting/add', // 菜品标签设置 - 新增菜品标签
        meta: { auth: true },
        component: resolve => require(['../pages/setting/label/label-add'], resolve)
      },
      {
        path: '/label-setting/modify', // 菜品标签设置 - 修改菜品标签
        meta: { auth: true },
        component: resolve => require(['../pages/setting/label/label-add'], resolve)
      },
      {
        path: '/discount-list',
        name: 'discount-list',
        meta: { auth: true, menu: true, title: '优惠活动设置' },
        component: resolve => require(['../pages/setting/Discount/discount-list'], resolve)
      },
      {
        path: '/discount-list/modify', //   优惠活动 添加 修改
        meta: { auth: true },
        component: resolve => require(['../pages/setting/Discount/discount-add-modify'], resolve)
      },
      {
        path: '/discount-list/add', //   优惠活动 添加 修改
        meta: { auth: true },
        component: resolve => require(['../pages/setting/Discount/discount-add-modify'], resolve)
      },
      {
        path: '/employee-setting',
        name: 'employee-setting',
        meta: { auth: true, menu: true, title: '员工设置' },
        component: resolve => require(['../pages/setting/employee/employee-setting'], resolve)
      },
      {
        path: '/employee-name-modify',
        name: 'employee-name-modify',
        meta: { auth: true, menu: true, title: '员工姓名修改' },
        component: resolve => require(['../pages/setting/employee/employee-name-modify'], resolve)
      },
      {
        path: '/employee-setting/add', // 员工设置 - 新增员工
        meta: { auth: true },
        component: resolve => require(['../pages/setting/employee/employee-add'], resolve)
      },
      {
        path: '/employee-setting/modify', // 员工设置 - 修改员工
        meta: { auth: true },
        component: resolve => require(['../pages/setting/employee/employee-add'], resolve)
      },
      {
        path: '/employee-operate',
        name: 'employee-operate',
        meta: { auth: true, menu: true, title: '上传员工数据' },
        component: resolve => require(['../pages/batch/employee-operate'], resolve)
      },
      {
        path: '/', // 首页
        meta: { auth: true },
        component: resolve => require(['../pages/index'], resolve)
      },
      {
        path: '/recharge-setting',
        name: 'recharge-setting',
        meta: { auth: true, menu: true, title: '充值金额设置' },
        component: resolve => require(['../pages/setting/recharge/recharge'], resolve)
      },
      {
        path: '/subscriber-list',
        name: 'subscriber-list',
        meta: { auth: true, menu: true, title: '订阅者列表' },
        component: resolve => require(['../pages/daily/subscribers/subscriber-list'], resolve)
      },
      {
        path: '/subscriber-listxcc',
        name: 'subscriber-listxcc',
        meta: { auth: true, menu: true, title: '三方支付对账单' },
        component: resolve => require(['../pages/daily/subscribers/payrecord'], resolve)
      },
      {
        path: '/administrator-takesmeal',
        name: 'administrator-takesmeal',
        meta: { auth: true, menu: true, title: '管理员取餐' },
        component: resolve => require(['../pages/daily/subscribers/administrator-takesmeal'], resolve)
      },
      {
        path: '/subscriber-list/add',
        meta: { auth: true },
        component: resolve => require(['../pages/daily/subscribers/subscriber-add'], resolve)
      },
      {
        path: '/upload-img',
        meta: { auth: true },
        component: resolve => require(['../pages/daily/upload-img'], resolve)
      },
      {
        path: '/delayUploadOrders-search',
        name: 'elayUploadOrders-search',
        meta: { auth: true, menu: true, title: '延时上传订单查询' },
        component: resolve => require(['../pages/query-and-statics/delayUploadOrders-search'], resolve)
      },
      {
        path: '/refund-statics',
        name: 'refund-statics',
        meta: { auth: true, menu: true, title: '批量扣款记录查询' },
        component: resolve => require(['../pages/query-and-statics/refund-statics'], resolve)
      },
      {
        path: '/poundage-list',
        name: 'poundage-list',
        meta: { auth: true, menu: true, title: '工本费' },
        component: resolve => require(['../pages/query-and-statics/poundage-list'], resolve)
      },
      {
        path: '/withdrawal-list',
        name: 'withdrawal-list',
        meta: { auth: true, menu: true, title: '提现记录查询' },
        component: resolve => require(['../pages/query-and-statics/withdrawal-list'], resolve)
      },
      {
        path: '/asyn-list',
        name: 'asyn-list',
        meta: { auth: true, menu: true, title: '导出任务' },
        component: resolve => require(['../pages/query-and-statics/fingerprint-list'], resolve)
      },
      {
        path: '*', //  其他页面，强制跳转到登录页面
        redirect: '/login'
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/config/routes.js